import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Bot, Landmark, ShieldCheck } from "lucide-react";
import { API, useAuth } from "@/lib/auth";
import { Skel } from "@/components/market/Shared";
import { ExchangeCard } from "@/components/auto/ExchangeCard";
import { StrategyLab } from "@/components/auto/StrategyLab";

const HOW = [
  [Landmark, "Your bank stays with the exchange", "Deposit and withdraw at Kalshi, Polymarket US or Coinbase. They're the regulated exchanges holding your money."],
  [ShieldCheck, "Connect with an API key", "Paste a trading key. It's encrypted, and it can't withdraw your funds."],
  [Bot, "Pick a bot, start on paper", "Watch it trade $1,000 of practice money, then flip to real (Pro) when you like the results."],
];

export default function AutoTrade() {
  const { profile } = useAuth();
  const [d, setD] = useState(null);
  const load = () => axios.get(`${API}/auto/state`).then((r) => setD(r.data)).catch(() => setD({ error: true }));
  useEffect(() => { if (profile) load(); }, [profile]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="space-y-6" data-testid="auto-page">
      <section>
        <div className="text-[11px] font-bold uppercase tracking-[.18em] text-[var(--cyan)]">Auto-trade</div>
        <h1 className="font-head font-extrabold text-4xl sm:text-5xl mt-1">Bots that trade for you</h1>
        <p className="text-sm text-slate-400 mt-2 max-w-2xl">Connect your own exchange accounts. Our bots place the trades and every bet is sized from your balance with daily loss stops. You just deposit and withdraw at the exchange. No bot can promise profits, so check the honest results in the Strategy lab.</p>
        <div className="grid sm:grid-cols-3 gap-2.5 mt-4 stagger">{HOW.map(([I, t, x]) => (
          <div key={t} className="glass p-4"><I className="w-5 h-5 text-[var(--cyan)]" /><div className="font-semibold text-sm mt-2">{t}</div><p className="text-xs text-slate-400 mt-1">{x}</p></div>))}</div>
      </section>
      {!profile ? <div className="glass p-6 text-sm text-slate-300" data-testid="auto-signin">Create a free account to connect exchanges and run paper bots. <Link to="/account" className="text-[var(--cyan)] font-semibold">Sign in or sign up</Link></div> :
        !d ? <Skel h="h-72" /> : d.error ? <p className="text-sm text-slate-400">Couldn't load your bots. Try again.</p> :
          <div className="grid lg:grid-cols-3 gap-4 items-start stagger">{Object.entries(d.exchanges).map(([ex, e]) => <ExchangeCard key={ex} ex={ex} e={e} d={d} reload={load} />)}</div>}
      <StrategyLab />
    </div>
  );
}
